import { Quote } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { JOIN } from "@/constants/testIds";

export default function TestimonialSection() {
  return (
    <section
      data-testid={JOIN.testimonial}
      className="section-pad-lg dark-section"
      style={{ textAlign: "center" }}
    >
      <div
        className="container-narrow"
        style={{ maxWidth: 820, position: "relative", zIndex: 1 }}
      >
        <Reveal>
          <div
            className="eyebrow eyebrow--light mb-6"
            style={{ justifyContent: "center" }}
          >
            Partner voices
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="type-section-heading on-dark-heading mb-10">
            What our partners say.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <div
            style={{
              background: "rgba(255,255,255,0.06)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 12,
              padding: 48,
              maxWidth: 720,
              margin: "0 auto",
              position: "relative",
            }}
          >
            <Quote
              size={48}
              strokeWidth={1}
              style={{
                color: "#b9b9f9",
                opacity: 0.55,
                position: "absolute",
                top: 24,
                left: 28,
              }}
            />
            <p
              className="type-body-large"
              style={{
                color: "#ffffff",
                fontStyle: "italic",
                lineHeight: 1.7,
                fontSize: 19,
                marginTop: 8,
              }}
            >
              I&apos;ve been a SmartEdge Agent for 6 months. I&apos;ve
              enrolled 3 clients and now earn over $4,000/month in residual
              income — just from those 3 accounts. The programs sell themselves
              because they genuinely help businesses. This is the best
              partnership opportunity I&apos;ve found.
            </p>
            <div className="mt-8" style={{ color: "rgba(255,255,255,0.9)" }}>
              <div style={{ fontSize: 14, fontWeight: 600 }}>Adam P.</div>
              <div style={{ fontSize: 13, opacity: 0.75 }}>
                Business Consultant · Ohio
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
